import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LiveDataService } from '../live-data/live-data.service';
import {
	AddEmergencyReq,
	AddPassEventMessageReq,
	GetEmergencyEventReq,
	PassEvent,
	PassEventCheckin,
	PassEventCheckinReq,
	PassEventCheckins,
	PassEventMessage,
	PassEventMessageReq,
	UpdateEmergencyEventReq,
	UpsertPassEventCheckinReq,
} from '../models/Emergency';
import { HttpService } from './http-service';
import { LiveUpdateEvent } from './live-update.service.types';

@Injectable({
	providedIn: 'root',
})
export class EmergencyService {
	isEmergencyActivated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(private http: HttpService, private liveData: LiveDataService) {}

	isRightSchool(school_id: number): boolean {
		return this.http.getSchool()?.id == school_id;
	}

	addEmergency(body: AddEmergencyReq): Observable<PassEventCheckin[]> {
		return this.http.post<PassEventCheckin[]>('v2/pass-events/add', body, undefined, false);
	}

	getEmergencyEvent(body: GetEmergencyEventReq): Observable<PassEvent[]> {
		return this.http.post<PassEvent[]>(`v2/pass-events`, body, undefined, false);
	}

	endEmergencyEvent(body: UpdateEmergencyEventReq): Observable<PassEvent> {
		return this.http.post<PassEvent>(`v2/pass-events/update`, body, undefined, false);
	}

	getEmergencyEventMessage(body: PassEventMessageReq): Observable<PassEventMessage[]> {
		return this.http.post<PassEventMessage[]>(`v2/pass-events/messages`, body, undefined, false);
	}

	addEmergencyEventMessage(body: AddPassEventMessageReq): Observable<PassEventMessage> {
		return this.http.post<PassEventMessage>(`v2/pass-events/messages/add`, body, undefined, false);
	}

	getCheckInList(body: PassEventCheckinReq): Observable<PassEventCheckins> {
		return this.http.post<PassEventCheckins>(`v2/pass-events/checkin/list`, body, undefined, false);
	}

	addCheckInList(body: UpsertPassEventCheckinReq): Observable<PassEventCheckin> {
		return this.http.post<PassEventCheckin>(`v2/pass-events/checkin/add`, body, undefined, false);
	}

	listenForEmergencyEventsCreate(): Observable<LiveUpdateEvent> {
		return this.liveData.watchCreatedEvents();
	}

	listenForEmergencyEventsCreatePublic(): Observable<LiveUpdateEvent> {
		return this.liveData.watchPublicCreatedEmergency();
	}

	listenForEmergencyEventsUpdatePublic(): Observable<LiveUpdateEvent> {
		return this.liveData.watchPublicUpdatedEmergency();
	}

	listenForEmergencyEventsUpdate(): Observable<LiveUpdateEvent> {
		return this.liveData.watchUpdatedEvents();
	}

	listenForEmergencyMessageUpdate(): Observable<LiveUpdateEvent> {
		return this.liveData.watchEmergencyMessages();
	}

	listenForEmergencyStudentCheckin(): Observable<LiveUpdateEvent> {
		return this.liveData.watchEmergencyStudentCheckin();
	}

	isPassEvent(obj: any): obj is PassEvent {
		return obj && typeof obj.locations !== 'undefined' && typeof obj.message === 'string';
	}

	isPassEventMessage(obj: any): obj is PassEventMessage {
		return obj && typeof obj.event_id !== 'undefined' && typeof obj.message === 'string';
	}

	isPassEventCheckins(obj: any): obj is PassEventCheckins {
		return obj && typeof obj.event_checkins !== 'undefined' && Array.isArray(obj.event_checkins);
	}
}
